import Cookies from 'js-cookie'
import moment from 'moment'  
import axios from 'axios'  
import jwt_decode from "jwt-decode";

export default { 
    
    getLoggedInOrganization: function( isAdmin, passed_organizationID = null ) {
                
        let user = Cookies.get('user')
        //user = JSON.parse( atob( user ) )
        user = jwt_decode(Cookies.get('user-token'))
        
        
        let orgID;

        isAdmin = user.admin
        
        if( Cookies.get('atlass_lio') ){
            if( isAdmin ){
                let org = Cookies.get('atlass_lio')
                //org = JSON.parse( atob( org ) )
                org = jwt_decode(Cookies.get('atlass_lio'))
                //console.log(org)
                orgID = org.ID
            }else{
                //SIGNAL SECURITY ISSUE
                
            }
        }else{
            
            //console.log( user )
            //IF ORGID IS PASSED AS PROP
            if( passed_organizationID ){
                //ORGANIZATION ID IS PASSED AS PROP
                orgID = passed_organizationID
            }else{
                //USER ORGANIZATION ID
                orgID =  user.organizationID;
            }
        }  
        
        //return
        return orgID
        
    },
    
    getAdminLevel: function(){
        
        let user = Cookies.get('user')
        user = JSON.parse( atob( user ) )
        
        return user.adminRole;
        
    },
    
    getCurrency: function(){
        
        
        let CURRENCY = {currency: "USD", currency_symbol_position: "front", currency_symbol: "$"}
        let db_currency;    
        
        if( Cookies.get('atlass_lio') ){
            let org = JSON.parse( atob( Cookies.get('atlass_lio') ) )
            //console.log( org )
            if( org.settings && org.settings.currency ){
                
               db_currency = org.settings.currency
                
            }
            
        }else if( Cookies.get('user') ){
            let user = Cookies.get('user')
            user = JSON.parse( atob( user ) )
            if( user.settings && user.settings.currency ){
                
                db_currency = user.settings.currency
                
            }
            
        }
        
        //console.log(db_currency)
        
        CURRENCY.currency  = db_currency 
        if( db_currency == "EUR" ){ 
            CURRENCY.currency_symbol  = "€" 
            CURRENCY.currency_symbol_position  = "back" 
        }
        if( db_currency == "RON" ){ 
            CURRENCY.currency_symbol  = "lei" 
            CURRENCY.currency_symbol_position  = "back" 
        }
        
        //CURRENCY = db_currency
        //console.log(CURRENCY)
        return CURRENCY
        
    },
    
    getAccountTimezone: function(){
        
        
        let TIMEZONE = 'UTC'
        
        if( Cookies.get('atlass_lio') ){
            let org = JSON.parse( atob( Cookies.get('atlass_lio') ) )
            //console.log( org )
            if( org.settings && org.settings.timezone ){
                TIMEZONE = org.settings.timezone
            }
            
        }else if( Cookies.get('user') ){
            let user = Cookies.get('user')
            user = JSON.parse( atob( user ) )
            //console.log(user)
            if( user.settings && user.settings.timezone ){
                TIMEZONE = user.settings.timezone
            }
            
        }
        
        return TIMEZONE
        
    },
    
    getAccountSettings: function(){
        
        
        let SETTINGS = false
        
        if( Cookies.get('atlass_lio') ){
            let org = JSON.parse( atob( Cookies.get('atlass_lio') ) )
            //console.log( org )
            if( org.settings  ){
                SETTINGS = org.settings
            }
            
        }else if( Cookies.get('user') ){
            let user = Cookies.get('user')
            user = JSON.parse( atob( user ) )
            //console.log(user)
            if( user.settings ){
                SETTINGS = user.settings
            }
            
        }
        
        return SETTINGS
        
    },
    
    formatNumberWithCurrency( value ){
        
        let formattedValue, result
        value = parseFloat(value)

        if( value % 1 === 0 ){
            value = value
        }else{
            value = value.toFixed(2)
        }

        formattedValue = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        
        let CURRENCY = this.getCurrency()
        if( CURRENCY.currency_symbol_position == 'back' ){
            result = formattedValue + CURRENCY.currency_symbol
        }else{
            result = CURRENCY.currency_symbol + "" + formattedValue
        }
        
        return result;
        
    },
    
    formatDate( timestamp, format = 'MMM D, HH:mm:ss' ){
        
        let accountTimezone = this.getAccountTimezone()   
        //console.log( accountTimezone )
        //console.log( timestamp )
        //console.log( moment.unix(timestamp).tz('UTC').format( format ) )
        //console.log( moment.unix(timestamp).tz(accountTimezone).format( format ) )
        //timestamp in unix
        return moment.unix(timestamp).tz(accountTimezone).format( format )
        
    },
    
    Numberformatter(value, type, html, color = 'normal' ) {
            
        //type: number -> add currency / percentage -> % / plain -> just 
        
        let final_result
        let result
        let formattedValue
        value = parseFloat(value)

        if( value % 1 === 0 ){
            value = value
        }else{
            value = value.toFixed(2)
        }

        formattedValue = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        //let currency_symbol = 'lei'

        if( value  >= 0 ){
            if( type == 'number' ){
                //result = currency_symbol + formattedValue;
                //GET CURRENCY SYMBOL AND GENERATED FORMATED RESULT
                let CURRENCY = this.getCurrency()
                if( CURRENCY.currency_symbol_position == 'back' ){
                    result = formattedValue + CURRENCY.currency_symbol
                }else{
                    result = CURRENCY.currency_symbol + "" + formattedValue
                }
            }else if( type == 'percentage' ){
                result = formattedValue + "%";
            }else if( type == 'plain-number' ){
                result = formattedValue
            }

            if( html ){
                if( color == 'normal' ){
                    final_result = '<b class="color-green" >'+ result +'</b>'
                }else{
                    final_result = '<b class="color-red" >+'+ result +'</b>'
                }
            }else{
                final_result = result
            }


        }else{
            if( type == 'number' ){
                //let v = value * -1
                let v = value 
                //console.log(v)
                formattedValue = v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                //result = '-'+ currency_symbol + formattedValue;
                //GET CURRENCY SYMBOL AND GENERATED FORMATED RESULT
                let CURRENCY = this.getCurrency()
                if( CURRENCY.currency_symbol_position == 'back' ){
                    result = formattedValue + CURRENCY.currency_symbol
                }else{
                    result = CURRENCY.currency_symbol + "" + formattedValue
                }
            }else if( type == 'percentage' ){
                result = formattedValue + "%";
            }else if( type == 'plain-number' ){
                result = formattedValue
            }

            if( html ){
                if( color == 'normal' ){
                    final_result = '<b class="color-red" > '+ result +'</b>'
                }else{
                    final_result = '<b class="color-green" > '+ result +'</b>'
                }
            }else{
                final_result = result
            }

        }

        return final_result;

    },
    
    secondsToDhms(seconds) {
            
        seconds = Number(seconds);
        var d = Math.floor(seconds / (3600*24));
        var h = Math.floor(seconds % (3600*24) / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var s = Math.floor(seconds % 60);
        
        /*
        var dDisplay = d > 0 ? d + (d == 1 ? " day " : " days ") : "";
        var hDisplay = h > 0 ? h + (h == 1 ? " hour " : " hours ") : "";
        var mDisplay = m > 0 ? m + (m == 1 ? " minute " : " minutes ") : "";
        var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
        */
        
        var dDisplay = d > 0 ? d + (d == 1 ? "d " : "d ") : "";
        var hDisplay = h > 0 ? h + (h == 1 ? "h " : "h ") : "";
        var mDisplay = m > 0 ? m + (m == 1 ? "m " : "m ") : "";
        
        return dDisplay + hDisplay + mDisplay ;

    },
    
    groupSalesBy( data, start, end, groupBy = null ){
            
            if(  data.length > 0 ){
                
                let format, group;
                if( groupBy == null ){
                    
                    if( ( moment( end ).unix() - moment( start ).unix() ) < ( 60*60*24 ) ){
                        group = 'HH:00 MMM D';
                        groupBy = 'hours'
                        format = 'HH:00 MMM D'
                        format = "YYYY-MM-DD HH:00"
                    }else{
                        group = 'MMM D';
                        groupBy = 'days'
                        format = 'MMM D'
                        format = "YYYY-MM-DD"
                    }
                    
                }else{
                    if( groupBy == 'hours' ){
                        group = 'HH:00 MMM D';
                        groupBy = 'hours'
                        format = 'HH:00 MMM D'
                    }
                }
                         
                
                let timezone = this.getAccountTimezone()
                let startDate, endDate
                if( typeof start == 'number' ){
                    startDate = moment.unix(start)
                    endDate = moment.unix(end) 
                }else{
                    startDate = moment(start)
                    endDate = moment(end)
                }
                                
                let max = endDate.diff(startDate, groupBy)
                                
                let final = []
                for( let i = 0; i <= max; i++ ){
                    let G = { datetime: startDate.format( group ), date: startDate.format( format ), count: 0, list: [] }
                    if( startDate.unix() <= moment().unix() ){
                        final.push( G )
                    }
                    
                    
                    startDate.add(1, groupBy)
                }
                                
                data.forEach((child)=>{
                    //let date = this.$moment.unix(child.datetime).tz(timezone).format( format )
                    let date = this.formatDate( child.datetime, format )
                    //console.log(format + " " + date)
                    
                    final.forEach((day)=>{
                        if( day.date == date ){
                            day.count += 1
                            day.list.push( child )
                        }
                    })
                })
                    
                return final
                
            }else{
                return []
            }
            
        },
    
    uniqueItems (list, keyFn){
        
         return list.reduce((resultSet, item) =>
            resultSet.add(typeof keyFn === 'string' ? item[keyFn] : keyFn(item)),
          new Set).size
        
    },
    
    calculateLTV( data, start, end ){
        
        // DOCS
        //  - https://blog.hubspot.com/service/how-to-calculate-customer-lifetime-value
        //  - https://blog.digitalj2.com/a-simple-customer-lifetime-value-formula
        
        // Customer Lifetime Value = (Customer Value * Average Customer Lifespan)
        // Customer Value = Average Purchase Value * Average Number of Purchases
        
        // Average Purchase Value = Total Revenue / Number of purchases
        // Average Purchase Frequency Rate = Number of Purchases / Number of Customers ( that made purchases during that timeperiod )
        // Customer Value =  Average Purchase Value * Average Purchase Frequency Rate
        
        // Average Customer Lifespan = Sum of Customer Lifespan / Number of Customers
        // Sum of Customer Lifespan = Sum of ( 1st Orderdate - Last order date ) in years
        
        // Customer Lifetime Value (CLTV) = Customer Value * Average Customer Lifespan
        
        // console.log(data)
        // console.log(start)
        // console.log(end)
    
        let NUMBER_OF_PURCHASES = data.length
        let NUMBER_OF_CUSTOMERS = this.uniqueItems( data, 'leadID' )
        let TOTAL_REVENUE = 0
        data.forEach((order)=>{
            if( order.status != 'refunded' && order.status != 'failed' ){
                TOTAL_REVENUE += parseFloat(order.price)
            }
        })
        
        //CALCULATE AVG CUSTOMER LIFESPAN
        let uniqueData = data.sort((a, b) => b.datetime - a.datetime);
        uniqueData.filter((v,i,a)=>a.findIndex(t=>(t.leadID===v.leadID))===i)
        
        NUMBER_OF_CUSTOMERS = uniqueData.length
        
        let SUM_LIFESPAN = 0
        uniqueData.forEach((purchase)=>{
            let tags = purchase.tags.filter(item => {
                if(item.type == 2){
                    return item
                } 
            })
            tags.sort((a, b) => b.datetime - a.datetime);
            //console.log( tags )
            
            purchase.customer_lifespan_old = ( ( tags[0].datetime - tags[ tags.length - 1 ].datetime ) / (60*60*24) ).toFixed(2)
            //purchase.customer_lifespan = ( ( tags[ 0 ].datetime - purchase.lead.datetime_created ) / (60*60*24) ).toFixed(2)
            
            SUM_LIFESPAN += parseFloat( purchase.customer_lifespan )
            //console.log(purchase)
        })
        
        //console.log( "TOTAL_REVENUE: "+ TOTAL_REVENUE )
        //console.log( "NUMBER_OF_CUSTOMERS: "+ NUMBER_OF_CUSTOMERS )
        
        let AVG_PURCHASE_VALUE = parseFloat( TOTAL_REVENUE ) / parseFloat( NUMBER_OF_PURCHASES )
        let AVG_PURCHASE_FREQ_RATE = parseFloat( NUMBER_OF_PURCHASES ) / parseFloat( NUMBER_OF_CUSTOMERS )
        let CUSTOMER_VALUE = AVG_PURCHASE_VALUE * AVG_PURCHASE_FREQ_RATE
        
        //console.log(" AVG CUSTOMER LIFESPAN: "+ ( SUM_LIFESPAN / NUMBER_OF_CUSTOMERS ) )
        //console.log(" AVG CUSTOMER LIFESPAN: "+ ( SUM_LIFESPAN / NUMBER_OF_CUSTOMERS )/ 365 )
        
        let AVG_CUSTOMER_LIFESPAN = 2.5
        //AVG_CUSTOMER_LIFESPAN = ( SUM_LIFESPAN / NUMBER_OF_CUSTOMERS )/ 365
        let CLTV = CUSTOMER_VALUE / AVG_CUSTOMER_LIFESPAN
        
        // console.log( "AVG_PURCHASE_VALUE: "+ AVG_PURCHASE_VALUE )
        // console.log( "AVG_PURCHASE_FREQ_RATE: "+ AVG_PURCHASE_FREQ_RATE )
        // console.log( "CUSTOMER_VALUE: "+ CUSTOMER_VALUE )
        // console.log( "AVG_CUSTOMER_LIFESPAN: "+ AVG_CUSTOMER_LIFESPAN )
        let LTV = {
            AVG_PURCHASE_VALUE: AVG_PURCHASE_VALUE.toFixed(2),
            AVG_PURCHASE_FREQ_RATE: AVG_PURCHASE_FREQ_RATE,
            AVG_CUSTOMER_LIFESPAN_DAYS: ( SUM_LIFESPAN / NUMBER_OF_CUSTOMERS ),
            AVG_CUSTOMER_LIFESPAN: AVG_CUSTOMER_LIFESPAN,
            CUSTOMER_VALUE: CUSTOMER_VALUE.toFixed(2),
            CLTV: "-",
        }
        
        if( CLTV != NaN ){
            LTV.CLTV = parseFloat( CLTV ).toFixed(2)
        }
        
        return LTV
        
    },
    
    groupResultsBy( type, data ){
                
        let results = []
        if( type == 'source' ){

            data.forEach((item)=>{

                if( item.sourceTag == null || !item.sourceTag ){
                    //item.sourceName = 'Unattributed'
                    //item.sourceTag = 'unattributed'
                    
                    item.sourceTag = { name: "Unattributed", tag: "unattributed" }
                }
                //console.log(item)
                //let found = results.find(el => el.tag == item.sourceTag )
                let found = results.find(el => el.tag == item.sourceTag.tag )

                //console.log(found)
                if( found == undefined ){

                    //let SOURCE = { name: item.sourceName, tag: item.sourceTag, engagements:[ ] }
                    let SOURCE = { name: item.sourceTag.name, tag: item.sourceTag.tag, engagements:[ ] }
                    SOURCE.engagements.push( item )

                    results.push( SOURCE );

                }else{

                    for( var i = 0; i < results.length; i++ ){
                        if( results[i].tag == item.sourceTag.tag  ){
                            results[i].engagements.push( item )                                
                        }
                    }

                }

            })

        }
        else if( type == 'previousURL' ){

            data.forEach((item)=>{
                //console.log( item.previousURL )
                let previousURLDomain = ""
                if( item.previousURL == null ){
                    previousURLDomain = 'Unknown'
                }else{
                    let url = (new URL( item.previousURL ));
                    previousURLDomain = url.hostname.replace('www.','');
                    //previousURLDomain = previousURLDomain.split('.')[ previousURLDomain.split('.').length - 2 ]
                }
                //console.log(item)
                
                //let found = results.find(el => el.previousURL.includes( previousURLDomain ) )
                let found = results.find(el => el.name == previousURLDomain )

                //console.log(found)
                if( found == undefined ){

                    let SOURCE = { name: previousURLDomain, engagements:[ ] }
                    SOURCE.engagements.push( item )

                    results.push( SOURCE );

                }else{

                    for( var i = 0; i < results.length; i++ ){
                        if( results[i].name == previousURLDomain  ){
                            results[i].engagements.push( item )                                
                        }
                    }

                }

            })

        }
        else if( type == 'refferalURL' ){

            data.forEach((item)=>{
                //console.log( item.referralURL )
                let LINK = ""
                if( item.referralURL == null ){
                    LINK = 'Unknown'
                }else{
                    let url = (new URL( item.referralURL ));
                    //LINK = url.hostname.replace('www.','');
                    //console.log(url)
                    LINK = url.href.split(/[?#]/)[0]
                    LINK = LINK.replace('https://www.','');
                    LINK = LINK.replace('http://www.','');
                    LINK = LINK.replace('https://.','');
                    LINK = LINK.replace('http://.','');
                }
                //console.log(item)
                
                //let found = results.find(el => el.previousURL.includes( LINK ) )
                let found = results.find(el => el.name == LINK )

                //console.log(found)
                if( found == undefined ){

                    let SOURCE = { name: LINK, engagements:[ ] }
                    SOURCE.engagements.push( item )

                    results.push( SOURCE );

                }else{

                    for( var i = 0; i < results.length; i++ ){
                        if( results[i].name == LINK  ){
                            results[i].engagements.push( item )                                
                        }
                    }

                }

            })

        }
        else{
            //URL PARAMETERS
            data.forEach((item)=>{
                //console.log(item)
                let NAME = "No "+type+" parameter"
                if( item.referralURL.includes( type ) ){
                    let p = item.parameters.find(el => el.key == type )
                    NAME = p.value
                }else
                if( item.previousURL && item.previousURL != null && item.previousURL.includes( type ) ){
                    var url = new URL(item.previousURL);
                    var c = url.searchParams.get("c");
                    if( url.searchParams.has(type) ){
                        NAME = url.searchParams.get(type)
                    }
                    
                }
                
                //let found = results.find(el => el.previousURL.includes( previousURLDomain ) )
                let found = results.find(el => el.name == NAME )
                
                if( found == undefined ){

                    let SOURCE = { name: NAME, engagements:[ ] }
                    SOURCE.engagements.push( item )

                    results.push( SOURCE );

                }else{

                    for( var i = 0; i < results.length; i++ ){
                        if( results[i].name == NAME  ){
                            results[i].engagements.push( item )                                
                        }
                    }

                }

            })
            //URL PARAMETERS
        }
        
        return results
        
    },
    
    goToResource( resource ){
        
        //https://theatlass.com/resources/blog/metrics-explained/
        let link
        link = 'https://theatlass.com/resources/blog/metrics-explained/'
        window.window.open(link, '_blank');
        
    },
    
    getFunnelData( APPKEY, sales, period, funnel ){
            
        //console.log(sales)
        //console.log(funnel)
        
        funnel.loaded = false
        funnel.chartData = []
        ////////////////////////////////////////////////////////////////

        let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }

        let timezone = this.getAccountTimezone()            
        let start = moment.tz(period[0], timezone ).startOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
        let end = moment.tz(period[1], timezone ).endOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
        let offset = moment.tz(period[0], timezone ).format('Z')

        let signup = this.getAccountSettings().datetime
        if( moment.tz(period[0], timezone ).startOf('day').tz( 'UTC' ).unix() < signup ){
            //console.log( "Cannot request data for date prior to sign up" );
            start = moment.unix( signup ).tz("UTC").format( 'YYYY-MM-DD HH:mm:ss' )
        }

        funnel.steps.forEach((step, index)=>{

            let searchPhrase = step.link

            //step.count = 'loading'
            step.loaded = false

            if( step.ab_test ){
                
                step.links.forEach((link, i)=>{
                    
                    return axios({ 
                        method: 'post',
                        //url: 'https://sql.theatlass.com/api/list.php?s='+searchPhrase,
                        url: 'https://sql.theatlass.com/api-v2/getList.php?s='+link.link,
                        headers: { 
                            'Access-Control-Allow-Headers': '*', 
                            'Access-Control-Allow-Origin': '*',  
                            'Content-Type': 'application/json;' 
                        },
                        async: true,
                        data: { 
                            "APPKEY": APPKEY,
                            "startDate":  start,
                            "endDate":  end,
                            "tz_to": offset,
                            "searchPhrase": searchPhrase,
                        } 
                    })
                    .then(resp => {
                        //console.log(resp)
                        if( resp.status == 200 ){
                            let response_data = resp.data.data.results

                            //version 2 with list
                            link.data = response_data
                            link.count = link.data.length
                            
                            link.data.forEach((row)=>{
                                //step.data.push(row)
                            })

                        }else{
                            console.log("error getting data")
                        }                
                    })
                    .then((r)=>{
                        if( i == step.links.length - 1 ){
                            step.loaded = true
                            //step.data.filter((v,i,a)=>a.findIndex(t=>(t.leadID===v.leadID))===i)
                            //console.log(step.data)
                        }
                    })

                })
                
            }
            
            
            //AXIOS
            return axios({ 
                method: 'post',
                //url: 'https://sql.theatlass.com/api/list.php?s='+searchPhrase,
                url: 'https://sql.theatlass.com/api-v2/getList.php?s='+searchPhrase,
                headers: { 
                    'Access-Control-Allow-Headers': '*', 
                    'Access-Control-Allow-Origin': '*',  
                    'Content-Type': 'application/json;' 
                },
                async: true,
                data: { 
                    "APPKEY": APPKEY,
                    "startDate":  start,
                    "endDate":  end,
                    "tz_to": offset,
                    "searchPhrase": searchPhrase,
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){
                    let response_data = resp.data.data.results

                    //version 2 with list
                    step.data = response_data
                    step.count = step.data.length

                }else{
                    console.log("error getting data")
                }                
            })
            .then(function(){

                step.loaded = true
                //console.log( funnel.name + " - " + index + " - " + searchPhrase )

                let all_loaded = []
                let isReady = funnel.steps.every(data=> data.loaded)
                //console.log(isReady)
                if( isReady ){ 
                    funnel.steps.forEach((step, index)=>{
           
                        if( index > 0 ){                            
                            if( step.ab_test ){
                                //CURATE AB TEST STEP
                                //console.log(step)
                                step.links.forEach((stepLink)=>{
                                    console.log(stepLink.data)
                                    let curated = []
                                    stepLink.data.forEach((visitor)=>{
                                        
                                        //CURATE
                                        funnel.steps.forEach((previousStep, previousIndex)=>{
                                            if( previousIndex < index && previousStep.data.length > 0 ){
                                                previousStep.data.forEach((previousVisitor)=>{
                                                    if( visitor.leadID == previousVisitor.leadID && curated.find(el => el.leadID === visitor.leadID ) == undefined ){
                                                        //console.log(  visitor.sourceTag + " vs "+ previousVisitor.sourceTag )
                                                        if( visitor.sourceTag == null && previousVisitor.sourceTag != null ){
                                                            visitor.sourceTag = previousVisitor.sourceTag
                                                            visitor.sourceName = previousVisitor.sourceName
                                                        }
                                                        //console.log( visitor )
                                                        curated.push( visitor )
                                                    }
                                                })
                                            }

                                        })
                                        //CURATE
                                        
                                    })
                                    
                                    stepLink.data = curated 
                                    stepLink.count = stepLink.data.length
                                })
                                //CURATE AB TEST STEP
                            }else{
                                
                                //CURATE NORMAL STEP
                                let curated = []
                                step.data.forEach((visitor)=>{

                                    funnel.steps.forEach((previousStep, previousIndex)=>{
                                        if( previousIndex < index && previousStep.data.length > 0 ){
                                            previousStep.data.forEach((previousVisitor)=>{
                                                if( visitor.leadID == previousVisitor.leadID && curated.find(el => el.leadID === visitor.leadID ) == undefined ){
                                                    //console.log(  visitor.sourceTag + " vs "+ previousVisitor.sourceTag )
                                                    if( visitor.sourceTag == null && previousVisitor.sourceTag != null ){
                                                        visitor.sourceTag = previousVisitor.sourceTag
                                                        visitor.sourceName = previousVisitor.sourceName
                                                    }
                                                    //console.log( visitor )
                                                    curated.push( visitor )
                                                }
                                            })
                                        }

                                    })

                                })
                                step.data = curated 
                                step.count = step.data.length
                                //CURATE NORMAL STEP
                            }
                            
                                
                        }

                        step.exit = "-"
                        step.exitRate = "-"
                        if( index < funnel.steps.length - 1 ){
                            step.exit = (step.count - funnel.steps[index+1].count)
                            step.exitRate = (( step.exit / funnel.steps[0].count ) * 100).toFixed(2)
                        }
                            
                        
                        let CHART_COLUMNS = []
                        let CHART_SERIES = []
                        let groupped = this.groupSalesBy( step.data, start, end )
                        groupped.forEach((day)=>{
                            CHART_COLUMNS.push( day.date )
                            CHART_SERIES.push( day.count )
                        })

                        step.chartColumn = CHART_COLUMNS
                        step.chartSeries = CHART_SERIES

                        //addChartData
                        let chartData = {
                            name: step.link,
                            description: step.link,
                            data: CHART_SERIES,
                            columns: CHART_COLUMNS
                        }

                        //console.log( chartData )
                        funnel.chartData.push( chartData )


                    })

                    //GROUP BY SOURCE
                    let funnelSources = this.groupResultsBy( 'source', funnel.steps[0].data )
                    funnelSources.sort((a, b) => b.engagements.length - a.engagements.length);
                    funnel.sources = funnelSources
                    funnel.sourceChartSeries = []
                    funnel.sourceChartColumns = []
                    
                    funnelSources.forEach((r, i)=>{
                        funnel.sourceChartColumns.push( r.name )
                        funnel.sourceChartSeries.push( r.engagements.length )
                    })
                    //GROUP BY SOURCE
                    
                    if( funnel.conversions && funnel.conversions.length > 0 && sales.length > 0 ){

                        let curatedOrders = []
                        sales.forEach((order)=>{
                            funnel.conversions.forEach((tag)=>{
                                if( order.tag == tag ){
                                    curatedOrders.push( order )
                                }else{
                                    if( order.orderItems ){
                                        order.orderItems.forEach((orderItem)=>{
                                            if( tag == orderItem.tag ){
                                                curatedOrders.push( order )
                                            }
                                        })
                                    }
                                        
                                }
                            })
                        })

                        //console.log( curatedOrders )

                        let other = []
                        let final_curated = []
                        curatedOrders.forEach((order)=>{
                            if( funnel.steps[0].data.find(el => el.leadID === order.leadID ) != undefined ){
                                final_curated.push( order )
                            }else{
                                other.push(order)
                            }
                        })

                        //console.log( other )

                        //funnel.orders = final_curated
                        funnel.orders = final_curated

                    }
                    funnel.loaded = true 
                }

                step.loaded = true

            }.bind(this))
            .catch(error => {

                console.log(error)
                //this.getData()
                /*
                this.$toast.error({
                    title:'Error',
                    message:  'Error while fetching data. Please try hitting the request button again!'
                })
                */

            }); //end axios 
            //AXIOS

        })
        //console.log(this.selectedFunnel)

        ////////////////////////////////////////////////////////////////

        return funnel   
            
    }
    
};


// WEBPACK FOOTER //
// ./src/helpers/helpers.js